import {AncestorEventsEmitterMixin} from "./AncestorEventsMixins"
import $ from "jquery"
import _ from "underscore"
import KeyDownHandler from "./key_down_handler"
import {getInsideWindowWidth, getClientSize, getInsideWindowHeight, shiftTo, handleEscape} from "./atBrowserUtils"
import ScrollUtils from "./util/ScrollUtils"
import Ext from 'Ext'

/*
 * Id of HTML DOM object representing moire DIV.
 */
const DEFAULT_MOIRE_DIV_ID = "moireDiv"

/*
 * Id of HTML DOM object keeping HTML of the whole page. It is needed to block all page elements by placing in it moire.
 */
DHTMLPopupWithMoire.prototype.documentContainerId = "container";

/*
 * DHTMLPopupWithMoire is intended for showing pop-ups with moire.
 */
function DHTMLPopupWithMoire(popupId, moireDivId = DEFAULT_MOIRE_DIV_ID) {
    /*
     * Property to keep window resizing handler before popup showing.
     */
    this.previousWindowResizeHandler = window.onresize;
    /*
     * Property to keep moire DIV mouse down handler before popup showing.
     */
    this.previousMoireDivMouseDownHandler = null;
    /*
     * Id of HTML DOM object keeping popup HTML-code.
     */
    this.popupId = popupId;

    this.moireDivId = moireDivId
    
    /*
     * If page is fully loaded
     */
    this.pageLoaded = false;

    var thisPopup = this;
    $( document ).ready( function(){ thisPopup.pageLoaded = true; } );
}

DHTMLPopupWithMoire.prototype.getPopupEl = function() {
    return $("#" + this.popupId)
}

DHTMLPopupWithMoire.prototype.focusPopupOnShow = function () 
{
    this.focusPopup();
};
/*
 * Shows the pop-up. Pop-up showing is accompanied by moire showing which blocks all page elements except the
 * pop-up.
 */
DHTMLPopupWithMoire.prototype.show = function (animated) {
    showMoire(this.moireDivId,
              DHTMLPopupWithMoire.prototype.documentContainerId);
    // Use animated approach by default
    animated = _.isUndefined(animated) ? true : animated;
    
    var popupDiv = this.getPopupEl();
    if (animated)
    {
        popupDiv.atAnimation().fadeInWithScale(_.bind(this.onShowAnimationEnd, this));
    }
    else
    {
        popupDiv.show();
        this.onShowAnimationEnd();
    }


    this.centrePopup();
    this.focusPopupOnShow(); // focusing pop-up to get out focus from underlying content

    this.setupKeyDownHandler();

    this.previousWindowResizeHandler = window.onresize;
    this.setupWindowResizeHandler();

    this.previousMoireDivMouseDownHandler = this.getMoireDiv().onmousedown;
    this.setupMouseDownHandler();

    this.setupWheelEventListener();

    this.isShowed = true;

    this.initAncestorEventsEmitter(popupDiv);
};

/*
 * Hides popup. Special moire is hided too.
 */
DHTMLPopupWithMoire.prototype.hide = function (animated) {
    // Use animated approach by default
    animated = _.isUndefined(animated) ? true : animated;

    if (animated)
    {
        this.getPopupEl().atAnimation().fadeOutWithScale(_.bind(this.onHideAnimationEnd, this));
    }
    else
    {
        hideElement(this.getPopupEl()[0]);
        this.onHideAnimationEnd();
    }

    if (!this.previousMoireDivMouseDownHandler) 
        hideMoire(this.moireDivId, animated);

    this.restoreOnKeyDownHandler();
    window.onresize = this.previousWindowResizeHandler;

    this.getMoireDiv().onmousedown = this.previousMoireDivMouseDownHandler;

    this.isShowed = false;

    this.triggerOnHideEvent();
};

DHTMLPopupWithMoire.prototype.triggerOnHideEvent = function() {
    this.triggerDOMEvent("popup.hide");
}

DHTMLPopupWithMoire.prototype.restoreOnKeyDownHandler = function ()
{
    KeyDownHandler.restoreOnKeyDownHandler();
};

/*
 * Centres the pop-up on the screen.
 */
DHTMLPopupWithMoire.prototype.centrePopup = function () {
    var popup = this.getPopupEl()[0];

    var screenDimensions = getClientSize();
    var scrollXFactor = screenDimensions[0] - getInsideWindowWidth();
    var scrollYFactor = screenDimensions[1] - getInsideWindowHeight();

    shiftTo(popup,
            Math.max(2, (scrollXFactor + (screenDimensions[0] - scrollXFactor) / 2) - popup.offsetWidth / 2),
            Math.max(2, (scrollYFactor + (screenDimensions[1] - scrollYFactor) / 2) - parseInt(popup.offsetHeight, 10) / 2) );
};

/*
 * Focuses pop-up to get out focus from underlying content.
 */
DHTMLPopupWithMoire.prototype.focusPopup = function () {
    this.getPopupEl().find('div,span,td').first().focus();
};

DHTMLPopupWithMoire.prototype.getMoireDiv = function()
{
    return document.getElementById(this.moireDivId);
};

DHTMLPopupWithMoire.prototype.setupKeyDownHandler = function()
{
    var thisPopup = this; // dereferencing of THIS object to use it asynchronously in various handlers
    KeyDownHandler.setOnKeyDownHandler(function(evt) {
        handleEscape(function() {thisPopup.onEscape();}, evt);
    });
};

DHTMLPopupWithMoire.prototype.setupWindowResizeHandler = function()
{
    var thisPopup = this; // dereferencing of THIS object to use it asynchronously in various handlers

    window.onresize = function()
    {
        if( thisPopup.hideOnResize() && thisPopup.pageLoaded ) // do not hide popup on resize if page was not fully loaded
        {
            thisPopup.hide();
        }
        else
        {
            thisPopup.centrePopup();
        }
    };
};

DHTMLPopupWithMoire.prototype.hideOnResize = function()
{
    return true;
};

DHTMLPopupWithMoire.prototype.hideOnEscape = function()
{
    return true;
};

DHTMLPopupWithMoire.prototype.onEscape = function()
{
    if( this.hideOnEscape() )
    {
        this.hide();
    }
};

DHTMLPopupWithMoire.prototype.onHideAnimationEnd = function() {};
DHTMLPopupWithMoire.prototype.onShowAnimationEnd = function() {};

DHTMLPopupWithMoire.prototype.setupMouseDownHandler = function()
{
    var thisPopup = this; // dereferencing of THIS object to use it asynchronously in various handlers

    this.getMoireDiv().onmousedown = function()
      {
          if( thisPopup.hideOnMouseDown() )
              thisPopup.hide();
      };
};

DHTMLPopupWithMoire.prototype.hideOnMouseDown = function()
{
    return true;
};

/**
 * This method add event listener that prevent scroll window if there is scroll in popup
 */
DHTMLPopupWithMoire.prototype.setupWheelEventListener = function() {

    var self = this;

    var wheelListener = function(e) {

        if(!self.isShowed) {return;} // prevent event if popup is closed
        _.bind(ScrollUtils.getWheelEventListenerForPreventScrollParents(), this)(e);
    };

    // set correct event name depends on browser
    var wheelEventName = ScrollUtils.getWheelEventName();

    Ext.ComponentMgr.register = function(c){
        this.all.add(c);
        c.on("render", function(ctr, pos){
            $(ctr.el.dom).on(wheelEventName, wheelListener); // add event to new ext.js components that was rendered
        });
    };

    this.getPopupEl().on(wheelEventName, wheelListener); // add listener to all popup content

};

_.extend(DHTMLPopupWithMoire.prototype, AncestorEventsEmitterMixin);

export default DHTMLPopupWithMoire


// WEBPACK FOOTER //
// ./web/js/dhtml_popup_with_moire.js